import LayoutRouter from "layouts/LayoutRouter";
import AuthLayout from "layouts/AuthLayout";
import reviewItemRoutes from "pages/reviewItems/reviewItemsConfig";
import reviewRoutes from "pages/reviews/reviewsConfig";
import { lazy } from "react";
import ProtectedRoute from "routes/ProtectedRoute";

// once we have a more clear structure of the apps, we can move these sub pages into their own configs
// such as (reviews/create vs reviews/edit/...) with their own configs
const Dashboard = lazy(() => import("pages/dashboard/Dashboard"));
const UserChange = lazy(() => import("pages/userChange/UserChange"));
const Help = lazy(() => import("pages/help/Help"));
const NotSignedIn = lazy(() => import("pages/login/NotSignedIn"));

const routes = [
  {
    path: "",
    children: [
      {
        // protected pages - ProtectedRoute wraps LayoutRouter
        element: ProtectedRoute,
        path: "",
        children: [
          {
            element: LayoutRouter,
            path: "",
            children: [
              // other configs
              // Review routes - see src/pages/reviews/reviewsConfig.js              
              ...reviewRoutes,
              // Review item routes - see src/pages/reviewItems/reviewItemsConfig.js
              ...reviewItemRoutes,
              {
                element: Dashboard,
                path: "",
              },
              {
                element: () => <p>reports</p>,
                path: "reports",
              },
              {
                children: [
                  { path: "users", element: () => <p>settings-u</p> },
                  { path: "permissions", element: () => <p>settings-p</p> },
                  { path: "dashboard", element: () => <p>settings-d</p> },
                ],
                path: "settings",
              },
            ],
          },
        ],
      },
      // unprotected pages with header
      {
        element: AuthLayout,
        path: "",
        children: [
          {
            element: NotSignedIn,
            path: "not-signed-in",
          },
          {
            element: Help,
            path: "help",
          },
          {
            element: UserChange,
            path: "userChange",
          },
        ],
      },
    ],
  },
];
export default routes;
